import { SubscriptionStatus, SubscriptionTag } from '@/types';
import { buildAPIUrl, responseInterceptor, toQueryString } from '.';

export const saveUsersSubscribedTags = async (data: {
  userId: string;
  selectedTags: SubscriptionTag[];
  status: SubscriptionStatus;
}): Promise<void> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/StylusSubscriptionApi/SaveUsersSubscribedTags`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }),
  );
  return response.json();
};

export const getReportMatchesForWeek = async (params: {
  userId: string;
  startOfWeek: string;
}): Promise<{ cards: any[] }> => {
  const response = await responseInterceptor(
    await fetch(
      `${await buildAPIUrl()}/umbraco/Api/StylusSubscriptionApi/GetReportMatchesForWeek${toQueryString(params)}`,
    ),
  );
  return response.json();
};
